import { render, staticRenderFns } from "./SelectComm.vue?vue&type=template&id=6acc4ba0&"
import script from "./SelectComm.vue?vue&type=script&lang=js&"
export * from "./SelectComm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports